// extracted by mini-css-extract-plugin
export default {"tooltip":"DotNetixNameTooltip_tooltip__yLANh"};